import { Grid } from "@mui/material";
import { ICicularCategories, ICicularCategory } from "./ICircularCategory";
import './circularCategory.css'
import { useState } from "react";


export default function CircularCategory({ data, handleClick, isSelected }: ICicularCategory) {


    const handleCategorySelected = () => {

        handleClick!(data.id);
    }

    return (
        <>
            <Grid container item xs={3} justifyContent={"center"} onClick={handleCategorySelected} style={{ minWidth: "70px", maxWidth: "120px", maxHeight: "120px" }} >
                <div style={{ borderColor: isSelected ? "#0AB494" : "#D7DBEC" }} className="circle">
                    <p className="text" style={{ marginBottom: "0px", color: isSelected ? "#0AB494" : "#000", fontSize: "12px" }}>{data.englishTitle}</p>
                    <p className="text" style={{ marginTop: "0px", fontWeight: "bold", fontSize: "16px" }}>{data.title}</p>
                </div>
            </Grid >
        </>
    )
}